import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ServiceAreaNavigator from './components/ServiceAreaNavigator';
import ProjectCategoryGrid from './components/ProjectCategoryGrid';
import EssentialGuides from './components/EssentialGuides';
import FeaturedContractors from './components/FeaturedContractors';
import TrustSignals from './components/TrustSignals';
import WhyChooseUs from './components/WhyChooseUs';
import HowItWorks from './components/HowItWorks';
import ContractorBenefits from './components/ContractorBenefits';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <Hero />
        <ServiceAreaNavigator />
        <ProjectCategoryGrid />
        <EssentialGuides />
        <FeaturedContractors />
        <TrustSignals />
        <WhyChooseUs />
        <HowItWorks />
        <ContractorBenefits />
      </main>
      <Footer />
    </div>
  );
}
